import { Info } from 'lucide-react'
import React from 'react'

import { ThatchTooltip } from './reusable/Tooltip'

interface AccountAmountVisualProps {
  amount: string
  label: string
  tooltipDescription?: string
}

export const AccountAmountVisual: React.FC<AccountAmountVisualProps> = ({ amount, label, tooltipDescription }) => {
  return (
    <div>
      <h1 className='text-2xl'>{amount}</h1>
      <div className='space-x-2 flex mt-2'>
        <div className='text-xs text-gray-400 mt-1'>
          {label}
        </div>
        {
            tooltipDescription &&
              (
                <ThatchTooltip className='max-w-80' includeArrow text={tooltipDescription}>
                  <Info size={13} />
                </ThatchTooltip>
              )
          }
      </div>
    </div>
  )
}
